// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1VjWV","tab":"Tabs_tab__2YNMG","tabActive":"Tabs_tabActive__tR9OY"};